import { Component, ElementRef, Input, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { CellComponent, ColumnConfig } from 'material-dynamic-table';
import { DeviceDetectorService } from 'ngx-device-detector';
import { take } from 'rxjs/operators';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/dialog/custom-launch-dialog-config';
import { BaseStoreService } from 'src/app/service/base-store/base-store.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
// tslint:disable-next-line: max-line-length
// tslint:disable-next-line: max-line-length

@Component({
  selector: 'app-saved-carts-list-actions-cell',
  templateUrl: './saved-carts-list-actions-cell.component.html',
  styleUrls: ['./saved-carts-list-actions-cell.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SavedCartsListActionsCellComponent implements CellComponent, OnInit {
  @Input() column: ColumnConfig;
  @Input() row: any;
  dateFormatted: any;

  constructor(
    protected modalService: StandardModalService,
    private baseStoreService: BaseStoreService,
    public deviceDetectorService: DeviceDetectorService,
    private el: ElementRef,
    private vcr: ViewContainerRef
  ) {}

  ngOnInit() {
    this.baseStoreService.baseStoreDateFormat$.pipe(take(1)).subscribe((dateFormat) => {
      if (dateFormat) {
        this.dateFormatted = dateFormat.replace(/\//g, '');
      }
    });
  }

  onRestoreSavedCartModal() {
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.RESTORE_SAVED_CART, this.el, this.vcr, {
        cartId: this.row.code,
        cartName: this.row.name,
        cartTotalItems: this.row.totalItems,
        dateFormatted: this.dateFormatted,
        reorder: false,
      })
      ?.pipe(take(1))
      .subscribe();
  }

  onDeleteSavedCartModal() {
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.DELETE_SAVED_CART, this.el, this.vcr, {
        cartId: this.row.code,
        cartName: this.row.name,
      })
      ?.pipe(take(1))
      .subscribe();
  }
}
